import { FilterDefaultValues } from '../../../shared/components/filter-menu/models/filterTypes.model';
import { ActionOrdersFilter } from '../../../shared/objects/enum/actionOrdersFilter';
import { DateShortFilter } from '../../../shared/objects/enum/dateShortFilter';
import { StatusArrived } from '../../../shared/objects/enum/statusArrived';
import { StatusLoaded } from '../../../shared/objects/enum/statusLoaded';
import { FieldDefinitionModel } from '../field-definition.model';
import { FilterSearch } from '../filter-search.model';
import { FilterModel } from '../filter.model';

import { OrderDefaultFilters } from './order-default-filters';

export class OrderListFilters {
  public static shortDate: FilterModel[] = [
    {
      value: FilterDefaultValues.TextDefault,
      viewValue: FilterDefaultValues.TextDefault,
      option: null,
    },
    {
      value: 'FILTERS.TODAY',
      viewValue: 'FILTERS.TODAY',
      option: DateShortFilter.Today,
    },
    {
      value: 'FILTERS.LAST-WEEK',
      viewValue: 'FILTERS.LAST-WEEK',
      option: DateShortFilter.LastWeek,
    },
    {
      value: 'FILTERS.THIS-WEEK',
      viewValue: 'FILTERS.THIS-WEEK',
      option: DateShortFilter.ThisWeek,
    },
    {
      value: 'FILTERS.NEXT-WEEK',
      viewValue: 'FILTERS.NEXT-WEEK',
      option: DateShortFilter.NextWeek,
    },
    {
      value: 'FILTERS.LAST-MONTH',
      viewValue: 'FILTERS.LAST-MONTH',
      option: DateShortFilter.LastMonth,
    },
    {
      value: 'FILTERS.THIS-MONTH',
      viewValue: 'FILTERS.THIS-MONTH',
      option: DateShortFilter.ThisMonth,
    },
    {
      value: 'FILTERS.NEXT-MONTH',
      viewValue: 'FILTERS.NEXT-MONTH',
      option: DateShortFilter.NextMonth,
    },
  ];

  public static statuses: FilterModel[] = [
    {
      value: FilterDefaultValues.TextDefault,
      viewValue: FilterDefaultValues.TextDefault,
      option: null,
    },
    {
      value: 'Announced to carrier',
      viewValue: 'Announced to carrier',
      option: 3,
    },
    {
      value: 'Arrived at loading',
      viewValue: 'Arrived at loading',
      option: StatusArrived,
    },
    {
      value: 'Loaded',
      viewValue: 'Loaded',
      option: StatusLoaded,
    },
    {
      value: 'Departed',
      viewValue: 'Departed',
      option: 8,
    },
    {
      value: 'Delivered',
      viewValue: 'Delivered',
      option: 9,
    },
    {
      value: 'Carrier accepted',
      viewValue: 'Carrier accepted',
      option: 11,
    },
    {
      value: 'Time expired',
      viewValue: 'Time expired',
      option: 13,
    },
  ];

  public static actionOrders: FilterModel[] = [
    {
      value: FilterDefaultValues.TextDefault,
      viewValue: FilterDefaultValues.TextDefault,
      option: null,
    },
    {
      value: 'ORDER-LIST.IN-PROGRESS-NO-TIMESLOTS',
      viewValue: 'ORDER-LIST.IN-PROGRESS-NO-TIMESLOTS',
      option: ActionOrdersFilter.NoTimeslots,
    },
    {
      value: 'ORDER-LIST.IN-PROGRESS-INCOMPLETE-ACTUALS',
      viewValue: 'ORDER-LIST.IN-PROGRESS-INCOMPLETE-ACTUALS',
      option: ActionOrdersFilter.IncompleteActuals,
    },
    {
      value: 'ORDER-LIST.INVOICED-TEXT',
      viewValue: 'ORDER-LIST.INVOICED-TEXT',
      option: ActionOrdersFilter.Invoiced,
    },
  ];

  public static defaultFieldDefinitions: FieldDefinitionModel[] = [
    {
      type: 'select',
      name: 'dateShortFilters',
      translation: 'FILTERS.DATE-SHORT-FILTERS',
      placeholder: 'FILTERS.CHOOSE-DATE-SHORT-FILTERS',
      disabled: false,
      options: OrderListFilters.shortDate,
      value: 'FILTERS.THIS-WEEK',
      overrideFieldName: 'dateRange',
    },
    {
      type: 'select',
      name: 'actionOrders',
      translation: 'FILTERS.ACTION-ORDERS',
      placeholder: 'FILTERS.CHOOSE-ACTION-ORDERS',
      disabled: false,
      options: OrderListFilters.actionOrders,
    },
    {
      type: 'select',
      name: 'status',
      translation: 'Status',
      placeholder: 'FILTERS.CHOOSE-STATUS',
      disabled: false,
      options: OrderListFilters.statuses,
    },
    {
      type: 'rangedatepicker',
      placeholder: 'FILTERS.CHOOSE-DATE-RANGE',
      name: 'dateRange',
      translation: 'FILTERS.DATE-RANGE',
      overrideFieldName: 'dateShortFilters',
    },
  ];

  public static defaultFields: OrderDefaultFilters = {
    actionOrders: undefined,
    dateRange: null,
    dateShortFilters: 'FILTERS.THIS-WEEK',
    status: undefined,
  };

  public static filterSearch: FilterSearch = {
    filter: OrderListFilters.defaultFields,
    filterSearchValue: '',
  };
}
